<template>
	<Card class="account-form">
		<Loading v-if="isLoading" />
		<p v-else-if="isError">Something went wrong, please try again.</p>
		<template v-else>
			<form @submit.prevent="submit">
				<!-- Name and email -->
				<TwoColumn class="fieldset">
					<FieldInput
						required
						name="username"
						label="Name"
						v-model="fields.username"
						:errors="errors.username"
					/>
					<FieldSelect
						required
						name="role"
						label="Role"
						:options="roles"
						v-model="fields.role"
						:errors="errors.role"
					/>
				</TwoColumn>
				<!-- Password -->
				<TwoColumn class="fieldset">
					<FieldInput
						required
						:disabled="edit"
						type="email"
						name="email"
						label="Email"
						v-model="fields.email"
						:errors="errors.email"
					/>
					<FieldInput
						required
						name="password"
						label="Password"
						v-model="fields.password"
						:errors="errors.password"
					/>
				</TwoColumn>
				<div class="fieldset">
					<p>
						<strong>Note:</strong> Administrator accounts can create and delete
						other administrator accounts.
					</p>
				</div>
				<!-- Account ID -->
				<input type="hidden" v-model="fields.id" />
				<!-- Submit -->
				<div class="fieldset">
					<SubmitButton
						class="btn btn--submit"
						:label="submitLabel"
						v-bind="submitButton"
					/>
					<input
						type="button"
						class="btn btn--cancel"
						value="Cancel"
						@click="cancel"
					/>
				</div>
			</form>
		</template>
	</Card>
</template>

<script>
import Loading from '@/components/shared/Loading'
import Card from '@/components/shared/Card'
import FieldInput from '@/components/shared/FieldInput'
import FieldSelect from '@/components/shared/FieldSelect'
import SubmitButton from '@/components/shared/SubmitButton'
import TwoColumn from '@/components/shared/TwoColumn'

import api from '@/mixins/api'
import form from '@/mixins/form'

export default {
	name: 'AdminAccountForm',
	props: {
		edit: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			state: 'loading',
			rolesData: null
		}
	},
	computed: {
		roles() {
			return this.rolesData.roles.reduce((acc, role) => {
				// Ignore public roles
				if (role.type === 'public') return acc

				// Reduce to value + label
				const label = role.name
				const value = role.id
				return [...acc, { label, value }]
			}, [])
		},
		submitLabel() {
			return this.edit ? 'Save' : 'Create'
		},
		isLoading() {
			return this.state === 'loading'
		},
		isError() {
			return this.state === 'error'
		}
	},
	async created() {
		// Load admin roles
		try {
			this.rolesData = await this.get('/users-permissions/roles').then(res =>
				res.json()
			)
			this.state = 'ready'
		} catch (err) {
			this.state = 'error'
		}
	},
	mixins: [api, form.adminAccount],
	components: {
		Loading,
		Card,
		FieldInput,
		FieldSelect,
		SubmitButton,
		TwoColumn
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';
@import '~scss/mq';

.account-form {
	position: relative;
}

.fieldset {
	margin-bottom: 2rem;
}

.btn {
	width: 100%;

	&--cancel {
		@include button--large($black, transparent, $black, $grey-90);
	}

	& + & {
		margin: 1rem 0 0 0;
	}

	@include mq(md) {
		width: auto;
		& + & {
			margin: 0 0 0 1rem;
		}
	}
}
</style>
